import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NavigationService } from '../../../../../core/navigation.service';
import { SearchService } from '../../../../../shared/search/search.service';
import { SearchEvent } from '../../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT, REFRESH_SEARCH_EVENT, ITEM_CLICK_EVENT } from '../../../../../shared/search/search-constants';
import { SearchStatus } from '../../../../../shared/search/models/search-status.model';
import { ResourceService } from 'sce-core';
import { AlertService } from 'sce-core';
import { ActivatedRoute } from '@angular/router';
import { PlatformLocation, Location } from '@angular/common';

import { SearchableEntityServiceFactory } from '../../../../../shared/services/searchable-entity/searchable-entity-service-factory';
import { SearchableEntityConfig } from '../../../../../shared/models/searchable-entity-config';
import { SavedSearchService } from '../../../../../shared/search/saved-search.service';
import { SearchableEntityButtonService } from '../../../../../shared/services/searchable-entity/searchable-entity-button.service';
import { DataTableEditorService } from '../../../../../shared/search/results/data-table-editor.service';
import { TablePreference } from '../../../../../shared/search/models/table-preference.model';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { Condition, SearchCriteria } from '../../../../../shared/search/models/search-filter-model';
import { Preference } from '../../../../../shared/search/models/preference.model';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE, ADD_RECENT } from '../../../../../shared/models/user-favourite-event';
import { DATA_TABLE_LIST } from '../../services/pick-management-tables';
import { SearchParams } from '../../../../../shared/search/models/search-params.model';
import { PickManagementDataService } from '../../services/pick-management-data.service';
import { PickManagementDataEditorService } from '../../services/pick-management-editor.service';
import { DataTableConfig } from '../../../../../shared/search/models/data-table-config';
import { UserPreferenceService } from '../../../../../layout/home/services/user-preference.service';
import { ModalService } from '../../../../../shared/services/modal.service';
import { PickManagementButtonService } from '../../services/pick-management-button.service';
import { ShipmentOrderDataService } from '../../../shipment-order/services/shipment-order-data.service';
import { ShipmentOrderDataEditorService } from '../../../shipment-order/services/shipment-order-data-editor.service';
import { UserService } from '../../../../../core/security/user.service';

@Component({
  selector: 'lfwms-pick-management-search',
  templateUrl: './pick-management-search.component.html',
  styleUrls: ['./pick-management-search.component.css']
})
export class PickManagementSearchComponent implements OnInit, OnDestroy {

  // The factory for all the required services
  @Input() public serviceFactory: SearchableEntityServiceFactory;
  @Output() public valueChange: EventEmitter<any> = new EventEmitter();
  // The configuration object for the entity
  public entityConfig: SearchableEntityConfig;
  // helper services
  protected navService: NavigationService;
  protected resourceService: ResourceService;
  public savedSearchService: SavedSearchService;
  protected alertService: AlertService;
  protected userPreferenceService: UserPreferenceService;
  protected modalService: ModalService;

  // entity services
  public dataService: PickManagementDataService;
  public buttonService: SearchableEntityButtonService;
  public dataEditor: DataTableEditorService;

  private tablePreference: TablePreference;
  public favouriteIconFlag: boolean = false;
  public expandFilterAccordion: boolean = true;
  protected expandResultsAccordion: boolean = false;
  protected filterSearchEventSubscription: Subscription;
  protected resultSearchEventSubscription: Subscription;
  protected userPreferenceEventSubscription: Subscription;
  protected resultSearchServiceEventSubscription: Subscription;

  public filterSearchService: SearchService;
  public filterSearchStatus: SearchStatus;
  private defaultFilterCriteria: SearchCriteria;

  public resultSearchService: SearchService;
  public resultSearchParams: SearchParams;
  public resultSearchStatus: SearchStatus;

  public successMsg: string = '';
  public panel: any;
  public default: any;
  public showSearchResults: any = false;
  public dataTablesList: any;

  public searchCriteriaForInv: any;
  public selectedViewType: any;


  public searchDone: boolean = false;

  public selectedData: any;
  public popupService: SearchService;
  public type: any;
  public searchStatus: any;

  public tooltipPosition: string = 'bottom';
  public tooltipMessage: string = 'Add to Favourites';

  protected searchEventSubscription: Subscription;

  constructor(coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry,
    private activatedRoute: ActivatedRoute, public platformLocation: PlatformLocation,
    public location: Location, protected soDataService: PickManagementDataService, protected pmButtonService: PickManagementButtonService,
    protected soDataEditor: PickManagementDataEditorService, private userService: UserService) {
    this.serviceFactory = new SearchableEntityServiceFactory(soDataService, null, null, soDataEditor, pmButtonService);
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userPreferenceService = coreServiceRegistry.userPreferencesService;
    this.savedSearchService = sharedServiceRegistry.savedSearchService;
    this.alertService = sharedServiceRegistry.alertService;
    this.modalService = sharedServiceRegistry.sceModalService;
  }

  public ngOnInit() {
    this.initializeProperties();
    this.dataTablesList = DATA_TABLE_LIST;
    this.activatedRoute.params.subscribe(params => {
      const searchType = params['searchType'];
      const searchId = params['searchId'];
      this.expandFilterAccordion = true;
      // if there is a search id in the route, load it
      if (searchId && searchId === 'PRE') {
        this.dataService.selectedViewType = 'picksearchtd';
        this.prePopulateSearchCriteria();
      }  else {
        if (searchId) {
          this.loadSavedSearchCriteria(searchId, searchType);
        } else {
          this.dataService.selectedViewType = 'picksearchtd';
        }
        this.loadPage();
      }
    });
    this.dataService.setDisplayMode('V');


  }

  public subscribeForEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          this.favouriteIconFlag = false;
          // this.userPreferences.preferenceId = null;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }

  /**
   * Initialize the component properties
   */
  private initializeProperties() {
    this.dataService = <PickManagementDataService>this.serviceFactory.getDataService();
    this.dataService.displayMode = 'V';
    this.dataEditor = this.serviceFactory.getDataEditor();
    this.buttonService = this.serviceFactory.getButtonService();
    this.entityConfig = this.dataService.getEntityConfiguration();
    this.entityConfig.initializePrimarySearchForTableId(this.dataService.selectedViewType, '');
    this.filterSearchService = this.dataService.getNewFilterSearchService();
    this.searchStatus = this.filterSearchService.searchStatus;
    this.filterSearchService.searchParams.tableEditor = this.dataEditor;
    this.filterSearchService.tableIdforTablePref = 'picksearchtd';
    this.dataService.filterSearchService = this.filterSearchService;
    this.filterSearchService.clearSavedSearchConfig(); // Clear any old data
    this.filterSearchService.searchParams.isFullFetch = true;
    this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
    if (this.resultSearchService) {
      this.resultSearchService.searchStatus.hasResults = false;
    }
    this.filterSearchEventSubscription = this.filterSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          // filter search service cannot do any search. Simply delegate the call to the result search service
          this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
          this.loadResultDataForType(this.dataService.selectedViewType);
        }
      });
  }

  private loadPage() {
    this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
    this.filterSearchService.fetchMetadata().subscribe((metadata: any) => {
      this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
      this.initializeUserPreferences();
    });
    this.subscribeForUserPreferenceEvents();
  }

  private loadResultDataForType(type: string) {
    this.resultSearchService = this.getResultSearchServiceForViewType(type);
    this.resultSearchService.searchParams.tableId = this.dataService.selectedViewType;
    this.resultSearchService.searchParams.isFullFetch = true;
    if(this.dataService.selectedViewType === 'picksearchtd') {
      this.resultSearchService.searchParams.dataTableConfig.showIdAsAHyperLink = true;
      this.resultSearchService.searchParams.idProperty = 'orderKey';
      this.resultSearchService.searchParams.dataTableConfig.hiddenPropertiesForTable = ['pickDetailStatus'];
    }
    

    this.dataService.resultSearchService = this.resultSearchService;
    this.resultSearchParams = this.resultSearchService.searchParams;
    this.resultSearchStatus = this.resultSearchService.searchStatus;
    const searchCriteriaFilter: SearchCriteria = this.dataService.filterSearchService.getSearchCriteria();
    this.resultSearchService.setSearchCriteria(searchCriteriaFilter);
    this.resultSearchService.fetchMetadata().subscribe((metadata: any) => {
      this.resultSearchParams.tableId = this.dataService.selectedViewType; // default table id for loadByPage.
      this.resultSearchParams.dataTableConfig.supportFiltering = true;
      this.resultSearchService.performSearch();

    });
  }

  private getResultSearchServiceForViewType(type: string): SearchService {
    if (type === (this.resultSearchService ? this.resultSearchService.searchParams.tableId : 'null')) {
      return this.resultSearchService;
    }
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = type;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    if (this.buttonService) {
      searchParams.actionButtons = this.buttonService.getButtonsForPanel('search-table');
    }
    searchService.searchParams.tableEditor = this.dataEditor;
    if (this.resultSearchEventSubscription) {
      this.resultSearchEventSubscription.unsubscribe();
    }
    searchService.searchParams.idProperty = 'orderKey';
    this.resultSearchEventSubscription = searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          this.buttonService.initializeSearchPageButtons();
          this.filterSearchService.searchParams.tableId = this.dataService.selectedViewType;
          this.expandFilterAccordion = false;
          this.showSearchResults = true;
          this.expandResultsAccordion = true;
        } else if (event.type === ITEM_CLICK_EVENT) {
          // this.dataService.setPrimarySelectedDocument(event.selectedItemId);
          this.showDetailsPage(event.selectedItemId);
      }
      });
    return searchService;
  }

  /* This method will create new search condition */
  public createSearchCondition(i: number) {
    const searchCondition = new Condition();
    searchCondition.id = i;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  public handleViewChange(selectedViewType: string) {
    const oldValue = this.selectedViewType;
    this.selectedViewType = selectedViewType;
    this.filterSearchService.clearSavedSearchConfig();
    let selectedRows;
    if (this.resultSearchService) {
      selectedRows = this.resultSearchService.getSelectedRows();
    }
    if (selectedRows && selectedRows.length > 0) {
      if (selectedRows.length === 1) {
        this.filterSearchService.searchParams.tableId = selectedViewType;
        const mainMetadData: any = this.filterSearchService.getMetadata();
        this.filterSearchService.fetchMetadataOnly().subscribe((metaData: any) => {
          const prevType = oldValue;
          const searchParams: SearchParams = new SearchParams();
          searchParams.tableId = selectedViewType;
          searchParams.isFullFetch = true;
          const tableConfig: DataTableConfig = new DataTableConfig();
          tableConfig.supportFiltering = true;
          searchParams.dataTableConfig = tableConfig;
          const searchStatus = new SearchStatus();
          this.popupService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
          let title: string = '';
          for (let i = 0; i < this.dataTablesList.length; i++) {
            if (this.dataTablesList[i].key === selectedViewType) {
              title = this.dataTablesList[i].value;
            }
          }
          this.type = prevType;
        });
      } else if (selectedRows.length > 1) {
        this.alertService.error(this.resourceService.get('err_msg_inv'));
        return;
      }
    } else {
      this.dataService.selectedViewType = selectedViewType;
      this.filterSearchService.setMetadata('');
      this.initializeProperties();
      this.loadPage();
      if (this.resultSearchService) {
        this.resultSearchService.searchStatus.hasResults = false;
      }
      this.expandFilterAccordion = true;
      this.filterSearchService.getSavedSearchConfig().searchName = null;
      this.filterSearchService.clearSavedSearchConfig();
    }
  }

  /**
   * Initialize the page based on the user preferences for the current search
   */
  private initializeUserPreferences() {
    this.tablePreference = this.filterSearchService.getTablePreference();
    const favPreference: Preference = this.tablePreference.favouriteConfig;
    if (favPreference && favPreference.configuration) {
      this.favouriteIconFlag = favPreference.configuration.favourite;
    }
  }

  /**
   * Subscribe for the search and user preference events
   */
  private subscribeForUserPreferenceEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          this.favouriteIconFlag = false;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }

  private prePopulateSearchCriteria() {
    // clear the search results
    this.searchStatus.hasResults = false;
    const formattedCriteria = this.userService['SearchCriteriaToPrePopulate'];
    if (!formattedCriteria) {
      this.alertService.error('Invalid search criteria');
      return;
    }
    // populate the search criteria from service
    this.filterSearchService.setSearchCriteria(formattedCriteria);
    this.filterSearchService.setNonMandatoryConditionsCount(0);
    this.filterSearchService.getSearchCriteria().conditions.forEach((condition) => {
      if (condition.isMandatory === false) {
        this.filterSearchService.setNonMandatoryConditionsCount(this.filterSearchService.getNonMandatoryConditionsCount() + 1);
      }
    });
    // get result for prepopulated search criteria
    this.filterSearchService.performSearch();
  }

  /**
   * If the page is loaded using a search criteria id, prepopulate the search filter
   * @param searchId - The search id
   */
  private loadSavedSearchCriteria(searchId, searchType) {
    this.filterSearchService.clearSavedSearchConfig(); // Clear any old data
    if (searchType === 'picksearch') {
      this.filterSearchService.searchParams.tableId = 'picksearchtd';
      this.dataService.selectedViewType = 'picksearchtd';
    } else if (searchType === 'pickstatusinquiry') {
      this.filterSearchService.searchParams.tableId = 'pickstatusinquirytd';
      this.dataService.selectedViewType = 'pickstatusinquirytd';
    }

    // clear the search results
    this.savedSearchService.loadSearchCriteria(searchId, this.filterSearchService.getSavedSearchConfig()).subscribe((resp: any) => {
      if (resp['statusCode'] && resp['statusMessage']) {
        if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
          const formattedCriteria = this.savedSearchService.transformSearchCriteriaToModel(resp, this.filterSearchService);
          if (!formattedCriteria) {
            this.alertService.error('Invalid search criteria');
            return;
          }
          this.defaultFilterCriteria = formattedCriteria;
          this.filterSearchService.setSearchCriteria(this.defaultFilterCriteria);
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(resp.error);
        }
      }
    }, (error) => {
      this.alertService.clearAll().error(error);
    });
  }

  // method used to translate the labels
  public getLabel(key) {
    return this.resourceService.get(key);
  }

  // add/remove favorite config
  public toggleFavourites() {
    // if the page is set as favourite, for every dropdown it should be enabled hence savig for a single table name
    if (this.favouriteIconFlag === false) {
      const userPreferences = {
        dataTableId: 'picksearchtd',
        prefType: 'FAVOURITECONFIG',
        configuration: { 'favourite': true }
      };
      this.userPreferenceService.saveTablePreferences(userPreferences).subscribe((data: any) => {
        this.favouriteIconFlag = true;
        this.tablePreference.favouriteConfig = data;
        this.notifyUserPreferenceEvent(ADD_FAVOURITE);
        this.alertService.success(this.resourceService.get('msg_fav_add'));
      }, (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error.error.errors['0'].validationMessage));
      });
    } else {
      this.userPreferenceService.deleteFavorites(this.tablePreference.favouriteConfig.preferenceId).subscribe((data: any) => {
        this.favouriteIconFlag = false;
        this.tablePreference.favouriteConfig = null;
        this.alertService.success(this.resourceService.get('msg_fav_del'));
        this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
      });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

  public toggleFilterAccordion() {
    this.expandFilterAccordion = !this.expandFilterAccordion;
  }

  public toggleResultsAccordion() {
    this.expandResultsAccordion = !this.expandResultsAccordion;
  }

  /**
   * Handle the button actions on page. The call is delegated to the corresponding button service
   */
  public handleButtonPanelActions(panelId: string, action: any) {
    this.buttonService.performButtonActions(action);
  }

/**
   * This method opens the details page for the selected items
   *
   * @param id - item id
   * @param isCreateItem - is it a create event
   */
 protected showDetailsPage(id, isCreateItem?: boolean) {
  if (isCreateItem) {
    this.dataService.setDisplayMode('C');
  } else {
    this.dataService.setDisplayMode('V');
  }
  //  this.navService.navigateByUrl(this.entityConfig.getDetailPageRoute());
  const selectedDetailrows = this.resultSearchService.getSelectedRows();
  let isExternal: boolean;
  if (selectedDetailrows.length > 0) {
    selectedDetailrows.forEach(element => {
      const IdcolumnName = this.resultSearchService.searchParams.idProperty;
      const detailPageUrl = (this.platformLocation as any).location.origin
        + this.location['_baseHref'] +
        this.entityConfig.getDetailPageRoute() + '/'
         +  encodeURIComponent(element.cells[IdcolumnName].cVal);
      // LFWM-3484 Close existing tab page if user click to open the same record again
      if(window['win'+detailPageUrl] != null){
        window['win'+detailPageUrl].close();
      }
      window['win'+detailPageUrl] = window.open(detailPageUrl);
    });
    isExternal = true;
  }
  if (!(this.checkIsSelectedDetail(id, selectedDetailrows))) {
    this.navService.navigateWithRouteParams(this.entityConfig.getDetailPageRoute(), [id]);
  }
  this.notifyUserPreferenceEvent(ADD_RECENT, isExternal);
}

public checkIsSelectedDetail(selectedId, selectedDetailrows) {
  let isIdSelected = false;
  selectedDetailrows.map(element => {
    const IdcolumnName = this.resultSearchService.searchParams.idProperty;
    if (selectedId === element.cells[IdcolumnName].cVal) {
      isIdSelected = true;
    }
  });
  return isIdSelected;
}

  /**
   * Cleanup the subscriptions
   */
  public ngOnDestroy() {
    this.filterSearchService.setNonMandatoryConditionsCount(0);
    if (this.filterSearchEventSubscription) {
      this.filterSearchEventSubscription.unsubscribe();
    }
    if (this.resultSearchEventSubscription) {
      this.resultSearchEventSubscription.unsubscribe();
    }
    if (this.userPreferenceEventSubscription) {
      this.userPreferenceEventSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/pick-management/pick-management-home/pick-management-search/pick-management-search.component.ts